import { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import Button from 'Components/UI/Button';
import Table from 'Components/UI/Table';
import { getColumnsTablePlot } from './index.helpers';
import { Icon } from 'Components/UI';
import { PlotagemActions } from 'Store/Plotagem/Plotagem.actions';
import { Skeleton } from 'antd';
import Form from 'Components/UI/Form/Form';
import Field from 'Components/UI/Field';
import schema from './index.schema';
import { Row, Col, Checkbox } from 'antd';
import { IReenviaPlotagem } from 'Data/interfaces/Plotagem/IReenviaPlotagem';
import { useTimeout } from 'Context/TimeoutContext';
import {
  FooterWrapper,
  FormWrapper,
  ModalStyled,
  TableWrapper,
} from './styles';
import { useParams } from 'react-router';

interface IModal {
  visible?: boolean;
  onCancel?: () => void;
  onConfirm?: () => void;
  isLoading?: boolean;
  constructionSiteId: number;
  props: React.PropsWithChildren<any>;
}

interface IMails {
  Email: string;
  isChecked: boolean;
}

const ReenvioSolicitacao: FC<IModal> = ({
  constructionSiteId,
  props,
  visible,
  onCancel,
}) => {
  const { t } = useTranslation('plotagens');
  const params = useParams();
  const dispatch = useDispatch();
  const { set, clear } = useTimeout();

  const [isSubmited, setIsSubmited] = useState(false);
  const [selectedPlot, setSelectedPlot] = useState([]);
  const [email, setNewEmail] = useState<string>('');
  const [nomeResponsavel, setNomeResponsavel] = useState<string>('');
  const [descricao, setDescricao] = useState<string>('');
  const [validateEmail, setValidateEmail] = useState(false);
  const [isShowRowEmail, setIsShowRowEmail] = useState(true);
  const [isStep, setStep] = useState(0);
  const [listaEmails, setlistaEmails] = useState<IMails[]>([]);
  const [selectedEmails, setSelectedEmails] = useState<string[]>();

  const onChange = (selecteds: any) => setSelectedPlot(selecteds);
  const rowSelection = {
    selectedPlot,
    onChange,
  };

  useEffect(() => {
    if (props.isLoading) { return; }
    setStep(0);
    setSelectedPlot([]);
  }, [props.submitedReenviaSolicitacaoPlotagem, dispatch]);

  const onChangeMail = (checkedValues: any) => {
    setSelectedEmails(checkedValues);
  };

  useEffect(() => {
    dispatch(PlotagemActions.listPlotagemSolicitacoesDisciplinas(Number(params.ConstructionSiteDisciplineFk)));
  }, [params.ConstructionSiteDisciplineFk, dispatch]);

  useEffect(() => {
    return () => {
      clear('ReenvioSolicitacao-cancelModal');
    };
  }, []);

  const boxHiddeShow = () => {
    setIsShowRowEmail(!isShowRowEmail);
  };

  const setStates = (
    submited: boolean,
    currentValidateEmail: boolean,
    e: any,
  ) => {
    e.form.reset();
    setIsSubmited(submited);
    setValidateEmail(currentValidateEmail);
  };

  const insertEmail = () => {
    if (isSubmited && email !== '' && validateEmail) {
      listaEmails.push({ Email: email, isChecked: false });
    }
    if (validateEmail) {
      boxHiddeShow();
    }
    setIsSubmited(false);
  };

  const selecionaEmails = () => {
    while (listaEmails.length) { listaEmails.pop(); }
    setNomeResponsavel(props.PlotagemSolicitacaoResponse.data[Number(selectedPlot)].PlotterResponsibleName);
    setDescricao(props.PlotagemSolicitacaoResponse.data[Number(selectedPlot)].Description);

    const resultadoEmails = props.PlotagemSolicitacaoResponse.data[Number(selectedPlot)].PlotterEmail.split(',');
    resultadoEmails.forEach((currentEmail: string) => {
      listaEmails.push({ Email: currentEmail, isChecked: false });
    });
    setlistaEmails(listaEmails);
    setStep(isStep + 1);
  };

  const reenviaPlotagem = () => {
    const mails: string[] = [];
    selectedEmails?.forEach((mail) => {
      mails.push(mail);
    });

    const plottingRequest: IReenviaPlotagem = {
      PlottingId: props.PlotagemSolicitacaoResponse.data[Number(selectedPlot)].PlottingId,
      ConstructionSiteId: constructionSiteId,
      Emails: mails,
    };
    setStep(isStep + 1);
    dispatch(PlotagemActions.reenviaPlotagem(plottingRequest));
  };

  const cancelModal = () => {
    dispatch(PlotagemActions.setShowModalReenviaSolicitacaoPlotagem(false));
    setSelectedPlot([]);
    clear('ReenvioSolicitacao-cancelModal');
    set('ReenvioSolicitacao-cancelModal', () => {
      setStep(0);
    }, 200);
  };

  const gerenciaBotao = () => {
    const qtEmailsSelected = selectedEmails?.length || 0;
    if ((selectedPlot.length === 1 && isStep === 0) || (qtEmailsSelected >= 1 && isStep === 1)) {
      return false;
    } else {
      return true;
    }
  };

  const mailCheck = (e: any, key: string) => {
    const emails = [...listaEmails];
    emails.forEach((emailData) => {
      if (emailData.Email == key) {
        emailData.isChecked = e.target.checked;
      }
    });
    setlistaEmails(emails);
  };

  const buttons = (
    <FooterWrapper>
      <Button height={37} onClick={cancelModal}>
        <span style={{ padding: '0 20px' }}>
          {t('resend.cancel')}
        </span>
      </Button>
      {isStep === 0 && (
        <Button
          type='primary'
          height={37}
          onClick={() => selecionaEmails()}
          loading={props.isLoading}
          disabled={gerenciaBotao()}
        >
          <span style={{ padding: '0 18px' }}>
            {t('resend.continue')}
          </span>
        </Button>
      )}
      {(isStep === 1 || isStep === 2) && (
        <Button
          type='primary'
          height={37}
          onClick={reenviaPlotagem}
          loading={props.isLoading}
          disabled={gerenciaBotao()}
        >
          <span style={{ padding: '0 18px' }}>
            {t('resend.resend')}
          </span>
        </Button>
      )}
    </FooterWrapper>
  );

  const steps = [
    {
      content: (
        <>
          {
            props.isLoading
              ? <Skeleton active />
              : (
                <Table
                  columns={getColumnsTablePlot()}
                  dataSource={props.PlotagemSolicitacaoResponse.data?.map((ploting: any, index: number) =>
                    ({ ...ploting, key: index }))}
                  scroll={{ y: 300 }}
                  isSpaced={true}
                  rowSelection={{
                    type: 'radio',
                    ...rowSelection,
                  }}
                  locale={{ emptyText: t('resend.emptyState') }}
                />
              )
          }
        </>
      ),
    },
    {
      content: (
        <FormWrapper>
          <div className='title'>
            <Row style={{
              display: 'flex',
              alignItems: 'center',
            }}>
              <Col span={1}>
                <Icon
                  color='cinzaPadrao'
                  icon='arquivar'
                  customSize={20}
                  className='icone'
                />
              </Col>
              <Col span={15}>
                <span className='spanSolicitacao'>{descricao}</span>
              </Col>
              <Col span={7}>
                <span className='spanSolicitacao'>{nomeResponsavel}</span>
              </Col>
            </Row>
          </div>
          <div>
            <Checkbox.Group
              style={{
                width: '100%',
                display: 'flex',
                flexDirection: 'row',
                flexWrap: 'wrap',
              }}
              onChange={onChangeMail}
            >
              {
                listaEmails?.map((mail) => (
                  <Row
                    key={mail.Email}
                    className={mail.isChecked ? 'MailsChecked' : 'Mails'}
                  >
                    <Col span={24} >
                      <Checkbox
                        value={mail.Email}
                        className='e-mail'
                        onChange={(e) => mailCheck(e, mail.Email)}
                      >
                        <span className='e-mail'>{mail.Email}</span>
                      </Checkbox>
                    </Col>
                  </Row>
                ))
              }
            </Checkbox.Group>
          </div>
          <div>
            <Form
              onSubmit={insertEmail}
              schema={schema}
              isSubmited={isSubmited}
              resetForm={true}
              className='formNovoEmail'
            >
              {
                (e: any) => (
                  <Row
                    justify='start'
                    className={isShowRowEmail ? 'NovoEmailHidde' : ''}
                  >
                    <Col span={24} >
                      <Field
                        name='Email'
                        label={t('resend.emailLabel')}
                        placeholder={t('resend.newEmailPlaceholder')}
                        value={email}
                        defaultValue={email}
                        onInput={setNewEmail}
                        className='fieldConfirmaAddEmail'
                      />
                      <Button
                        type='primary'
                        onClick={() => setStates(true, e.valid, e)}
                        width={99}
                        height={30}
                        className='btConfirmaAddEmail'
                      >
                        <span>
                          {t('resend.confirm')}
                        </span>
                      </Button>
                    </Col>
                  </Row>
                )
              }
            </Form>
            <Row>
              <Col span={24} >
                <span className='addNovoEmail' onClick={boxHiddeShow}>
                  {t('resend.addNewEmail')}
                </span>
              </Col>
            </Row>
          </div>
        </FormWrapper>
      ),
    },
    {
      content: <Skeleton loading={true} paragraph={{ rows: 3 }} />,
    },

  ];

  const contentSteps = (
    <TableWrapper>
      <div>{steps[isStep].content}</div>
    </TableWrapper>
  );

  return (
    <ModalStyled
      title={t('resend.modalTitle')}
      footerButtons={buttons}
      visible={visible}
      width={798}
      onCancel={onCancel}
      wrapClassName='modal'
      className='modalContainer'
      maskClosable={false}
    >
      {contentSteps}
    </ModalStyled>
  );
};

export default ReenvioSolicitacao;
